var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FEF9EB",
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 42C20.0477 42 19.6 42.4477 19.6 43C19.6 43.5523 20.0477 44 20.6 44V42ZM37.4 44C37.9523 44 38.4 43.5523 38.4 43C38.4 42.4477 37.9523 42 37.4 42V44ZM38.5 25.5C38.5 27.9062 36.9652 31.0074 34.8552 33.5773C33.8171 34.8418 32.6833 35.9228 31.6139 36.6784C30.5134 37.456 29.6073 37.8 29 37.8V39.8C30.2302 39.8 31.5553 39.1688 32.7681 38.3118C34.012 37.4328 35.2736 36.2196 36.401 34.8464C38.6223 32.1409 40.5 28.5921 40.5 25.5H38.5ZM29 37.8C28.4129 37.8 27.5158 37.4409 26.4094 36.6103C25.3383 35.8062 24.2017 34.6584 23.1601 33.3242C21.0436 30.6133 19.5 27.3716 19.5 24.9556H17.5C17.5 28.0378 19.3689 31.7183 21.5837 34.555C22.7077 35.9947 23.9664 37.2771 25.2086 38.2097C26.4155 39.1158 27.7496 39.8 29 39.8V37.8ZM19.5 24.9556C19.5 19.8408 24.047 16 29 16V14C23.1282 14 17.5 18.5592 17.5 24.9556H19.5ZM29 16C33.9162 16 38.5 19.8067 38.5 25.5H40.5C40.5 18.5933 34.9086 14 29 14V16ZM32.2 24.8C32.2 26.5673 30.7673 28 29 28V30C31.8719 30 34.2 27.6719 34.2 24.8H32.2ZM29 28C27.2327 28 25.8 26.5673 25.8 24.8H23.8C23.8 27.6719 26.1281 30 29 30V28ZM25.8 24.8C25.8 23.0327 27.2327 21.6 29 21.6V19.6C26.1281 19.6 23.8 21.9281 23.8 24.8H25.8ZM29 21.6C30.7673 21.6 32.2 23.0327 32.2 24.8H34.2C34.2 21.9281 31.8719 19.6 29 19.6V21.6ZM20.6 44H37.4V42H20.6V44Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.fdbfe533b01926f31aa1f60178a98642.svg";
export { ForwardRef as ReactComponent };